<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '120px'">
          <el-form-item label="名称" prop="name">
          <el-input v-model="dataForm.name" placeholder="名称"></el-input>
      </el-form-item>
          <el-form-item label="父Id" prop="pid">
          <el-input v-model="dataForm.pid" placeholder="父Id"></el-input>
      </el-form-item>
      <el-form-item label="城市" prop="city">
          <!-- <el-input v-model="dataForm.city" placeholder="城市"></el-input> -->
          <el-select v-model="dataForm.city" filterable clearable placeholder="请选择">
            <el-option v-for="item in cityList" :key="item.code" :value="item.name" :label="item.name"></el-option>
          </el-select>
      </el-form-item>
          <el-form-item label="排序" prop="sort">
          <!-- <el-input v-model="dataForm.sort" placeholder="排序"></el-input> -->
          <el-input-number v-model="dataForm.sort" controls-position="right" :min="0" ></el-input-number>
      </el-form-item>
          <el-form-item label="数量" prop="quantity">
          <!-- <el-input v-model="dataForm.quantity" placeholder="数量"></el-input> -->
          <el-input-number v-model="dataForm.quantity" controls-position="right" :min="0" ></el-input-number>
      </el-form-item>
          <el-form-item label="权重" prop="weights">
            <el-input-number v-model="dataForm.weights" controls-position="right" :min="0" ></el-input-number>
          <!-- <el-input v-model="dataForm.weights" placeholder="权重"></el-input> -->
      </el-form-item>
          <el-form-item label="负责人id" prop="ownerUserId">
          <el-input v-model="dataForm.ownerUserId" placeholder="负责人id"></el-input>
      </el-form-item>
      <el-form-item label="状态" prop="status">
          <!-- <el-input v-model="dataForm.status" placeholder="状态"></el-input> -->
          <el-select v-model="dataForm.status" placeholder="请选择">
            <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
      </el-form-item>
              <!-- <el-form-item label="删除时间" prop="deleteTime">
          <el-input v-model="dataForm.deleteTime" placeholder="删除时间"></el-input>
      </el-form-item>
          <el-form-item label="更新时间" prop="updateTime">
          <el-input v-model="dataForm.updateTime" placeholder="更新时间"></el-input>
      </el-form-item>
          <el-form-item label="更新人" prop="updateBy">
          <el-input v-model="dataForm.updateBy" placeholder="更新人"></el-input>
      </el-form-item> -->
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
import icityList from '../../../utils/city'
export default {
  data () {
    return {
      visible: false,
      cityList: [],
      statusList: [
        {
          label: '关',
          value: 0,
        },
        {
          label: '开',
          value: 1,
        },
      ],
      dataForm: {
        id: '',
        name: '',
        pid: '',
        city: '',
        sort: '',
        quantity: '',
        weights: '',
        ownerUserId: '',
        status: '',
        createDate: '',
        creator: '',
        deleteTime: '',
        updateTime: '',
        updateBy: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        name: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        pid: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        city: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        sort: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        quantity: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        weights: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        ownerUserId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        deleteTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateBy: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.getCityList()
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    getCityList(){
     this.cityList = icityList.provinces.map(item => {
        return item.cities.map(item1 => item1)
      }).flat(1)
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/distributioncontrol/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/distributioncontrol/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
